import React, { useState, useEffect, useRef } from 'react'
import CreateDatum from './CreateDatum/CreateDatum'
import { CreateItem } from './CreateItem/CreateItem'
import './Main.css'
import UserFeed from './UserFeed/UserFeed'
import DataFeed from './Feed/DataFeed'
import MainBar from './MainBar/MainBar'
import { useSelector } from 'react-redux'
import CategoryBrowse from './CategoryBrowse/CategoryBrowse'
import ItemFeed from './ItemFeed/ItemFeed'
import Datumdraft from './Feed/DatumState/Datumdraft'
import UnstampFeed from './Feed/unstampFeed'
import BusinessSuggestionCard from '../Survey/BusinessSuggestionCard'

const Main = () => {

  const [mainContent, setMainContent] = useState({ current: "itemFeed", previous: "itemFeed" });
  const { user } = useSelector((state) => state.authReducer.authData);
  // const { modalData } = useSelector((state) => state.modalReducer);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isOpen = useSelector((state) => state.datumeditReducer.isOpen)
  const sessionId = localStorage.getItem('sessionId');
  const subPageStartTime = useRef(null);
  const previousPage = useRef(null);
  const hasLoggedSubPage = useRef({});

  const subPageMap = {
      'itemFeed': 'browse_items',
      'dataFeed': 'browse_data',
      'categoryBrowse': 'browse_category',
      'userFeed': 'find_user',
  };

  useEffect(() => {
    const currentPageName = subPageMap[mainContent.current];
    const previousPageName = subPageMap[mainContent.previous];

    if (previousPageName && subPageStartTime.current && previousPage.current !== mainContent.current) {
        const duration = Math.floor((Date.now() - subPageStartTime.current) / 1000);
        const leaveDetails = {
            activity: "page_leave",
            category: "navigation",
            page: previousPageName,
            userId: user._id,
            data: {
              userId: user._id,
              username: user.username,
              duration: duration
            },
            sessionId,
            duration
        };
        const blob = new Blob(
            [JSON.stringify({ data: JSON.stringify(leaveDetails) })],
            { type: 'application/json' }
        );
        navigator.sendBeacon(
            `${process.env.REACT_APP_API_BASE_URL}/logs/beacon`,
            blob
        );
        hasLoggedSubPage.current[previousPageName] = false; 
    }

    // Log view for new sub-page
    if (currentPageName && !hasLoggedSubPage.current[currentPageName]) {
        hasLoggedSubPage.current[currentPageName] = true;
        subPageStartTime.current = Date.now();
        previousPage.current = mainContent.current;

        fetch(`${process.env.REACT_APP_API_BASE_URL}/logs`, {
            method: 'PUT',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                data: JSON.stringify({
                    activity: "page_view",
                    category: "navigation",
                    page: currentPageName,
                    userId: user._id,
                    data: {
                      userId: user._id,
                      username: user.username
                    },
                    sessionId,
                    referrer: null
                })
            })
        });
    }
  }, [mainContent.current]);

  var userFeedType;
  var userFeedText;
  switch (user.userType) {
    case 0:
      userFeedType = 2;
      userFeedText = "Group";
      break;
    case 1:
      userFeedType = 2;
      userFeedText = "Group";
      break;
    case 2:
      userFeedType = 1;
      userFeedText = "Author";
      break;
    default:
      break;
  }

  useEffect(() => {

    if (isOpen === true) {
      setIsModalOpen(true)
    }
    else {
      setIsModalOpen(false)
    }
  }, [isOpen])

  const renderContentComponent = () => {
    switch (mainContent.current) {
      case "itemFeed":
        return <ItemFeed />;
      case "dataFeed":
        return <DataFeed
          setMainContent={setMainContent} />;
      case "categoryBrowse":
        return <CategoryBrowse />;
      case "userFeed":
        return <UserFeed />;
      case "c_unstampedR":
        return <UnstampFeed activeTab={"pending"} setMainContent={setMainContent} />;
      case "c_unstampedD":
        return <UnstampFeed activeTab={"resolved"} setMainContent={setMainContent} />;
      case "c_item":
        return (
          <CreateItem
            setMainContent={setMainContent}
          />
        )
      case "c_datum":
        return (
          <CreateDatum
            setMainContent={setMainContent}
            ceFlag='1'
          />
        );
      case "c_datumview":
        return (
          <Datumdraft setMainContent={setMainContent} datumstate='draft' btn_flag='draft' />
        );
      default:
        return <ItemFeed />;
    }
  }

  return (
    <div className='Main'>
      <MainBar
        mainContent={mainContent}
        setMainContent={setMainContent}
        userFeedType={userFeedType}
        userType={user.userType}
        userFeedText={userFeedText}
        userId={user._id}
        username={user.username}
      />
      {renderContentComponent()}
    </div>
  )
}

export default Main